import { defineComponent as _defineComponent } from 'vue'

import { GigletsBookV1 } from '@ilteducation/content-registry-types';
import ChipField from '@/components/base/ChipField.vue';

type Props = {
  title: string;
  resource: unknown;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  resource: unknown;
}



const fields = [
  {
    source: 'coverUrl',
    sortable: false,
  },
  {
    source: 'id',
    link: 'show',
    sortable: true,
  },
  {
    source: 'title',
    sortable: true,
  },
  {
    source: 'author',
    sortable: true,
  },
  {
    source: 'readingLevel.name',
    sortable: true,
  },
  {
    source: 'languages.mainLanguage',
    sortable: true,
    label: 'Language',
    type: 'chip',
  },
  {
    source: 'state',
    sortable: true,
  },
];

const filters = [
  {
    source: 'state',
    type: 'select',
    attributes: {
      multiple: true,
    },
  },
  {
    source: 'languages.mainLanguage',
    label: 'Language',
    type: 'text',
    attributes: {
      multiple: true,
    },
  },
];

function getCoverUrl(item: GigletsBookV1) {
  const base = process.env.VUE_APP_GIGLETS_CONTENT_BASE_URL;
  return `${base}${item.coverUrl}`;
}

function getStateColor(state: GigletsBookV1['state']) {
  switch (state) {
    case 'published':
      return 'green';
    case 'disabled':
      return 'red';
    default:
      return 'yellow';
  }
}

return { __sfc: true,props, fields, filters, getCoverUrl, getStateColor, ChipField }
}

})